import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {dateSpan} from 'shared/tools';

class NmbrPayStub extends DomainObject {
  periodStart;
  periodEnd;
  id;

  constructor(other) {
    super();

    makeObservable(this, {
      periodStart: observable,
      periodEnd: observable,
      id: observable,
      dateRange: computed
    });

    this.merge(other);
  }

  get dateRange() {
    return dateSpan(this.periodStart, this.periodEnd, true);
  }
}

export default NmbrPayStub;
